import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/image/vipImg/icon_hint.png'


const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "auto-pay-disabled-title" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "flex-ter-cen" }

import { t } from '@/plugins/i18n'

import { useSite } from '@/store'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  beforehandVipInfo: {
    type: Object,
    default: () => { return {} }
  }
},
  emits: ['update:visible'],
  setup(__props, { emit }) {

const props = __props





return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "custom-class": "auto-pay-disabled",
    "model-value": __props.visible,
    onClose: _cache[1] || (_cache[1] = ($event: any) => (emit('update:visible', false))),
    draggable: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", {
            class: _normalizeClass(_unref(useSite)())
          }, _toDisplayString(_unref(t)('当前自动续费不可开启')), 3)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["auto-pay-disabled-content", _unref(useSite)()]),
          innerHTML: _unref(t)('您在持有预充会员【XX】期间，暂不可开启自动续费。在该预充会员正式开启后，我们会自动为您开启会员的自动续费，敬请谅解。').replace('【XX】', `<span style='color:#EB4545;'>【${ __props.beforehandVipInfo.membershipTemplateName }】</span>`)
        }, null, 10, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('update:visible', false))),
          style: {"width":"100px","height":"36px"}
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('知道了')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})